import { EditorTextarea } from '../EditorTextarea';
import { customizeCraftJsComponent } from '../../helpers';

export const EditorCertificateTextarea = customizeCraftJsComponent(
	EditorTextarea,
	{
		name: 'Certificate Textarea',
		props: {
			name: 'idpCert',
			placeholder: 'Certificate',
			label: 'Certificate'
		}
	}
);
